(function () {
    'use strict';

    angular
        .module('franchiser.directives')
        .directive('unitMachines', UnitMachines);

    /** @ngInject */
    function UnitMachines(UnitMachineService, HelperService, NotifyService, sweetAlert, PATHS_FRANCHISER, $q) {
        /** @ngInject */
        function UnitMachinesController($scope) {
            const vm = this;

            vm.machines = [];
            vm.categories = [];
            vm.manufacturers = [];
            vm.models = [];
            vm.maintenanceTypes = [];
            vm.selectedMachine = null;
            vm.showRegistryManager = false;
            vm.selectedRegistry = null;
            vm.registryItems = [];
            vm.isLoadingRegistryItems = false;
            vm.currentRegistryItem = null;
            vm.selectedTab = 1;
            vm.newMaintenance = {};
            vm.showMaintenanceForm = false;

            let initialized = false;

            vm.registryTypes = {
                manufacturers: {
                    title: 'Fabricantes',
                    itemName: 'fabricante',
                    load: UnitMachineService.getManufacturersAdmin,
                    save: UnitMachineService.postManufacturer,
                    update: UnitMachineService.putManufacturer,
                    remove: UnitMachineService.removeManufacturer
                },
                categories: {
                    title: 'Categorias',
                    itemName: 'categoria',
                    load: UnitMachineService.getCategoriesAdmin,
                    save: UnitMachineService.postCategory,
                    update: UnitMachineService.putCategory,
                    remove: UnitMachineService.removeCategory
                },
                models: {
                    title: 'Modelos',
                    itemName: 'modelo',
                    load: UnitMachineService.getModelsAdmin,
                    save: UnitMachineService.postModel,
                    update: UnitMachineService.putModel,
                    remove: UnitMachineService.removeModel
                }
            };

            vm.openMachine = machine => {
                vm.selectedMachine = normalizeMachineDates(angular.copy(machine));
                vm.showRegistryManager = false;
                vm.selectedRegistry = null;
                vm.selectedTab = 1;
                vm.showMaintenanceForm = false;
                vm.newMaintenance = {};
                loadMaintenances();
            };

            vm.closeMachine = () => {
                vm.selectedMachine = null;
                vm.showMaintenanceForm = false;
                vm.newMaintenance = {};
            };

            vm.openNewMachine = () => {
                vm.selectedMachine = {
                    UnitId: vm.unitData.Id,
                    Active: true,
                    HasRemoteControl: false,
                    isNew: true,
                    maintenances: []
                };
                vm.showRegistryManager = false;
                vm.selectedRegistry = null;
                vm.selectedTab = 1;
            };

            vm.openRegistryManager = () => {
                vm.selectedMachine = null;
                vm.showRegistryManager = true;
                vm.selectedRegistry = null;
                vm.registryItems = [];
                vm.currentRegistryItem = null;
            };

            vm.closeRegistryManager = () => {
                vm.showRegistryManager = false;
                vm.selectedRegistry = null;
                vm.registryItems = [];
                vm.currentRegistryItem = null;
            };

            vm.openRegistry = type => {
                vm.selectedMachine = null;
                vm.showRegistryManager = true;
                vm.selectedRegistry = vm.registryTypes[type];
                vm.registryItems = [];
                vm.currentRegistryItem = null;
                loadRegistryItems();
            };

            vm.closeRegistry = () => {
                vm.selectedRegistry = null;
                vm.registryItems = [];
                vm.currentRegistryItem = null;
            };

            vm.openNewRegistryItem = () => {
                vm.currentRegistryItem = {
                    Active: true,
                    isNew: true
                };
            };

            vm.editRegistryItem = item => {
                if (!vm.canUserEdit)
                    return;

                vm.currentRegistryItem = angular.copy(item);
                vm.currentRegistryItem.isNew = false;
            };

            vm.cancelRegistryItem = () => {
                vm.currentRegistryItem = null;
            };

            vm.saveRegistryItem = () => {
                if (!vm.currentRegistryItem || !vm.currentRegistryItem.Name) {
                    NotifyService.error('Informe o nome.');
                    return;
                }

                HelperService.startLoading('.loading-holder');

                const request = vm.currentRegistryItem.isNew
                    ? vm.selectedRegistry.save(vm.currentRegistryItem)
                    : vm.selectedRegistry.update(vm.currentRegistryItem);

                request.then(() => {
                    NotifyService.success(vm.currentRegistryItem.isNew ? 'Cadastro realizado!' : 'Cadastro atualizado!');
                    vm.currentRegistryItem = null;

                    $q.all([loadRegistryItems(), loadLookups()]).then(() => {
                        HelperService.stopLoading('.loading-holder');
                    });
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                });
            };

            vm.deleteRegistryItem = item => {
                sweetAlert.swal({
                    title: 'Inativar registro?',
                    text: item.Name,
                    type: 'warning',
                    confirmButtonText: 'Sim, inativar',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    allowOutsideClick: false
                }).then(response => {
                    if (!response.value) return;

                    HelperService.startLoading('.loading-holder');

                    vm.selectedRegistry.remove(item.Id).then(() => {
                        NotifyService.success('Registro inativado.');

                        $q.all([loadRegistryItems(), loadLookups()]).then(() => {
                            HelperService.stopLoading('.loading-holder');
                        });
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    });
                });
            };

            vm.changeTab = tab => {
                vm.selectedTab = tab;
            };

            vm.saveMachine = () => {
                if (!vm.selectedMachine.MachineCategoryId) {
                    NotifyService.error('Selecione uma categoria.');
                    return;
                }

                HelperService.startLoading('.loading-holder');

                const request = vm.selectedMachine.isNew
                    ? UnitMachineService.post(vm.selectedMachine)
                    : UnitMachineService.put(vm.selectedMachine);

                request.then(() => {
                    NotifyService.success(vm.selectedMachine.isNew ? 'Maquina cadastrada!' : 'Maquina atualizada!');
                    vm.closeMachine();
                    loadMachines();
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                });
            };

            vm.deleteMachine = machine => {
                sweetAlert.swal({
                    title: 'Remover maquina?',
                    text: getMachineTitle(machine),
                    type: 'warning',
                    confirmButtonText: 'Sim, remover',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    allowOutsideClick: false
                }).then(response => {
                    if (!response.value) return;

                    HelperService.startLoading('.loading-holder');

                    UnitMachineService.remove(machine.Id).then(() => {
                        NotifyService.success('Maquina removida.');
                        if (vm.selectedMachine && vm.selectedMachine.Id === machine.Id)
                            vm.closeMachine();
                        loadMachines();
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    });
                });
            };

            vm.openNewMaintenanceForm = () => {
                vm.newMaintenance = { UnitMachineId: vm.selectedMachine.Id };
                vm.showMaintenanceForm = true;
            };

            vm.cancelMaintenanceForm = () => {
                vm.showMaintenanceForm = false;
                vm.newMaintenance = {};
            };

            vm.saveMaintenance = () => {
                if (!vm.newMaintenance.MachineMaintenanceTypeId) {
                    NotifyService.error('Selecione o tipo de manutencao.');
                    return;
                }

                if (!vm.newMaintenance.ExecutionDate) {
                    NotifyService.error('Informe a data de execucao.');
                    return;
                }

                HelperService.startLoading('.loading-holder');

                UnitMachineService.postMaintenance(vm.newMaintenance).then(() => {
                    NotifyService.success('Manutencao registrada!');
                    vm.cancelMaintenanceForm();
                    loadMaintenances();
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                });
            };

            vm.deleteMaintenance = maintenance => {
                sweetAlert.swal({
                    title: 'Remover registro?',
                    text: `${maintenance.MachineMaintenanceType.Name} - ${maintenance.ExecutionDate}`,
                    type: 'warning',
                    confirmButtonText: 'Sim, remover',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    allowOutsideClick: false
                }).then(response => {
                    if (!response.value) return;

                    HelperService.startLoading('.loading-holder');

                    UnitMachineService.removeMaintenance(maintenance.Id).then(() => {
                        NotifyService.success('Registro removido.');
                        loadMaintenances();
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    });
                });
            };

            const removeWatchShow = $scope.$watchGroup(['vm.show', 'vm.unitData && vm.unitData.Id'], values => {
                if (values[0] && values[1]) init();
            });

            $scope.$on('$destroy', () => removeWatchShow());

            function init() {
                vm.canUserCreate = $scope.$root.canUserCreate;
                vm.canUserEdit = $scope.$root.canUserEdit;
                vm.canUserDelete = $scope.$root.canUserDelete;

                if (initialized) {
                    loadMachines();
                    return;
                }

                initialized = true;

                loadLookups().then(() => loadMachines(), error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                });
            }

            function loadLookups() {
                return $q.all([
                    UnitMachineService.getCategories().then(data => vm.categories = data),
                    UnitMachineService.getManufacturers().then(data => vm.manufacturers = data),
                    UnitMachineService.getModels().then(data => vm.models = data, () => vm.models = []),
                    UnitMachineService.getMaintenanceTypes().then(data => vm.maintenanceTypes = data)
                ]);
            }

            function loadRegistryItems() {
                if (!vm.selectedRegistry)
                    return $q.when();

                vm.registryItems = [];
                vm.isLoadingRegistryItems = true;

                return vm.selectedRegistry.load().then(data => {
                    vm.registryItems = data || [];
                }).finally(() => {
                    vm.isLoadingRegistryItems = false;
                });
            }

            function loadMachines() {
                HelperService.startLoading('.loading-holder');

                UnitMachineService.getByUnit(vm.unitData.Id).then(data => {
                    vm.machines = data.map(normalizeMachineDates);
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                });
            }

            function loadMaintenances() {
                if (!vm.selectedMachine || vm.selectedMachine.isNew) return;

                HelperService.startLoading('.loading-holder');

                UnitMachineService.getMaintenances(vm.selectedMachine.Id).then(data => {
                    vm.selectedMachine.maintenances = data.map(normalizeMaintenanceDates);
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                });
            }

            function normalizeMachineDates(machine) {
                if (machine.ManufactureDate)
                    machine.ManufactureDate = new Date(machine.ManufactureDate);

                if (machine.AcquisitionDate)
                    machine.AcquisitionDate = new Date(machine.AcquisitionDate);

                return machine;
            }

            function normalizeMaintenanceDates(maintenance) {
                if (maintenance.ExecutionDate)
                    maintenance.ExecutionDate = new Date(maintenance.ExecutionDate);

                return maintenance;
            }

            function getMachineTitle(machine) {
                if (!machine)
                    return '';

                let title = machine.MachineCategory ? machine.MachineCategory.Name : 'Maquina';

                if (machine.Model)
                    title += ` - ${machine.Model}`;

                return title;
            }
        }

        return {
            bindToController: true,
            controller: UnitMachinesController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/unit-machines/unit-machines.html`,
            scope: {
                unitData: '=',
                show: '='
            }
        };
    }
}());
